import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { BodyCellRenderResult, Column, RowTypeBase } from '@qre-mailing/smart-table';
import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  yes: { id: 'common.yes', defaultMessage: 'Yes' },
  no: { id: 'common.no', defaultMessage: 'No' },
  unknown: { id: 'booleanColumn.unknown', defaultMessage: 'Neznámo' },
});

const lowercaseFirstLetter = (str: string): string => str.charAt(0).toLowerCase() + str.slice(1);

export const createBooleanColumnRenderer =
  (intl: IntlShape) =>
  <RowType extends RowTypeBase>(row: RowType, column: Column<RowType>): BodyCellRenderResult => {
    const value = row[(column.fieldKey ?? lowercaseFirstLetter(column.fieldName)) as keyof RowType];
    const [Icon, color, message] =
      value === true
        ? ([CheckIcon, 'success', messages.yes] as const)
        : value === false
        ? ([CloseIcon, 'error', messages.no] as const)
        : ([RemoveIcon, 'disabled', messages.unknown] as const);
    // the cell uses value as its tooltip and hides the node when value is empty
    const label = intl.formatMessage(message);

    return {
      node: <Icon fontSize="small" color={color} role="img" aria-hidden={false} aria-label={label} />,
      value: label,
    };
  };
